import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="confirmation-modal">
      <div class="modal-header">
        <h2 class="modal-title">{{ data.title }}</h2>
      </div>

      <div class="modal-content">
        <div class="icon-container">
          <mat-icon class="confirmation-icon">question_mark</mat-icon>
        </div>
        <p class="message">{{ data.message }}</p>
      </div>

      <div class="modal-actions">
        <button mat-button class="cancel-button" (click)="onNoClick()">Cancelar</button>
        <button mat-raised-button class="confirm-button" (click)="onYesClick()">Confirmar</button>
      </div>
    </div>
  `,
  styles: [
    `
      .confirmation-modal {
        background: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        min-width: 400px;
        max-width: 500px;
      }

      .modal-header {
        background: #185564;
        color: white;
        padding: 16px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .modal-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
        }
      }

      .modal-content {
        padding: 24px 20px;
        text-align: center;

        .icon-container {
          margin-bottom: 16px;

          .confirmation-icon {
            font-size: 48px;
            width: 48px;
            height: 48px;
            color: #ff9800;
            background: rgba(255, 152, 0, 0.1);
            border-radius: 50%;
            padding: 8px;
          }
        }

        .message {
          margin: 0;
          font-size: 16px;
          line-height: 1.5;
          color: #333;
        }
      }

      .modal-actions {
        padding: 16px 20px;
        background: #f8f9fa;
        border-top: 1px solid #e9ecef;
        display: flex;
        justify-content: flex-end;
        gap: 12px;

        .cancel-button {
          color: #6c757d;
          border: 1px solid #dee2e6;

          &:hover {
            background: #e9ecef;
          }
        }

        .confirm-button {
          background: #185564;
          color: white;

          &:hover {
            background: #134a5a;
          }
        }
      }
    `
  ]
})
export class ConfirmationModalComponent {
  private readonly dialogRef = inject(MatDialogRef<ConfirmationModalComponent>);
  public readonly data = inject(MAT_DIALOG_DATA) as { message: string; title: string };

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
